import { render, staticRenderFns } from "./CmgAlternatePickupLocationsAlert.vue?vue&type=template&id=d25e463c&scoped=true&lang=pug"
import script from "./cmg-alternate-pickup-locations-alert.ts?vue&type=script&lang=ts&external"
export * from "./cmg-alternate-pickup-locations-alert.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgAlternatePickupLocationsAlert.vue?vue&type=style&index=0&id=d25e463c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25e463c",
  null
  
)

export default component.exports